module.exports = __webpack_public_path__ + "static/media/shadow-attack-2.95563a0c.png";